import { Home, HeartHandshake, Feather, Compass, CalendarDays } from "lucide-react";

const points = [
  { icon: Home, title: "Comfortable at-home experience", text: "Your space. Your pace. No clinics, no traffic — only ease." },
  { icon: HeartHandshake, title: "Personalised care", text: "Sessions shaped to your body's signals on the day." },
  { icon: Feather, title: "Calm & supportive environment", text: "A held, judgement-free presence — always." },
  { icon: Compass, title: "Holistic approach", text: "Body, breath, mind, and emotion treated as one." },
  { icon: CalendarDays, title: "Flexible scheduling", text: "Weekday mornings, evenings, and weekend slots." },
];

export default function WhyChoose() {
  return (
    <section className="py-24 md:py-32 bg-card/40">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5 reveal lg:sticky lg:top-32">
            <p className="text-xs uppercase tracking-[0.25em] text-secondary mb-4">Why Epic Heal</p>
            <h2 className="font-serif text-4xl md:text-5xl leading-tight">
              Healing that meets <span className="italic">you</span> — not the other way around.
            </h2>
            <p className="mt-6 text-muted-foreground leading-relaxed">
              We believe healing should feel like coming home. Not another appointment, not another prescription.
              Just a slow, intentional return to yourself.
            </p>
          </div>

          <ul className="lg:col-span-7 space-y-4">
            {points.map((p, i) => (
              <li
                key={p.title}
                data-testid={`why-card-${i}`}
                className="reveal group flex items-start gap-5 p-6 md:p-7 rounded-3xl bg-background border border-border/60 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-primary/10 transition-all duration-500"
                style={{ transitionDelay: `${i * 70}ms` }}
              >
                <div className="shrink-0 w-12 h-12 rounded-2xl bg-secondary/30 flex items-center justify-center group-hover:bg-secondary/60 transition-colors">
                  <p.icon size={20} className="text-foreground" />
                </div>
                <div>
                  <h3 className="font-serif text-2xl mb-1.5">{p.title}</h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">{p.text}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
